<template>
  <section class="BackgroundSection">
    <div class="container_row" v-if="this.screenWidth < 1000">
      <div class="layer2">
        <img
          class="smallImageMobile"
          alt="Angelguard logo"
          src="../assets/AGTRANSPARENT.png"
        />

        <section class="alignCentreMob">
          <b-row>
            <b-col cols="" class="leftCol">
              <h5 class="subtextHead">Log in</h5>
              <p>
                Access your Seraph Protect account and check the status of your
                water system.
              </p>
              <br />
              <button class="HomeButton" v-on:click="LogIn">Log in</button>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="" class="rightCol">
              <h5 class="subtextHead">What is Seraph Protect</h5>
              <p>
                Seraph Protect is a cloud-based water management system,
                designed to keep your water systems safe and compliant.
              </p>
              <br />
              <button class="HomeButton" v-on:click="goToSeraph()">
                More Information
              </button>
            </b-col>
          </b-row>
        </section>
      </div>
    </div>

    <div class="container_row" v-if="this.screenWidth >= 1000">
      <div class="layer1">
        <!-- <img
          class="bigImage"
          alt="Angelguard logo"
          src="../assets/AGTRANSPARENT.png"
        /> -->
      </div> 
      <div class="layer2">
        <img
          class="smallImage"
          alt="Angelguard logo"
          src="../assets/AGTRANSPARENT.png"
        />

        <section class="alignCentre">

          <b-row>
            <b-col cols="5" class="leftCol">
              <h5 class="subtextHead">Log in</h5>
              <p class="TextBlurb">
                Access your Seraph Protect account and check the status of your
                water system.
              </p>
              <br />
              <button class="HomeButton" v-on:click="LogIn">Log in</button>
            </b-col>
            <b-col cols="2" class="middleCol"></b-col>
            <b-col cols="5" class="rightCol">
              <h5 class="subtextHead">What is Seraph Protect</h5>
              <p class="TextBlurb">
                Seraph Protect is a cloud-based water management system,
                designed to keep your water systems safe and compliant.
              </p>
              <br />
              <button class="HomeButton" v-on:click="goToSeraph()">
                More Information
              </button>
            </b-col>
          </b-row>

        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {},
  components: {},

  data() {
    return {
      userid: "",
      password: "",
      show: false,
      loggedIn: false,
      profile: {},
      UserURN: null,
      expiryToken: "",
      dateCompare: "",
      CompareToken: "",
      dateForCompare: "",
      screenWidth: 0,
      MaxHeight: 0,
    };
  },

  mounted() {
    this.UserURN = this.$UserURN;
    this.expiryToken = localStorage.getItem("TokenExpiry");
    this.dateCompare = new Date();

    if (Date.parse(this.dateCompare) < Date.parse(this.expiryToken)) {
      this.$auth.login();
    } else if (Date.parse(this.expiryToken) < Date.parse(this.dateCompare)) {
      localStorage.setItem("TokenExpiry", "");

      this.$auth.logout();
      this.expiryToken = "";

      var cookies = document.cookie.split("; ");
      for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split(".");
        while (d.length > 0) {
          var cookieBase =
            encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
            "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
            d.join(".") +
            " ;path=";
          var p = location.pathname.split("/");
          document.cookie = cookieBase + "/";
          while (p.length > 0) {
            document.cookie = cookieBase + p.join("/");
            p.pop();
          }
          d.shift();
        }
      }
    }
    this.updateScreenWidth();
    this.onScreenResize();
  },
  methods: {
    LogIn() {
      this.$auth.login();
    },
    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    boxHeight() {
      let TextBoxHeight = document.getElementsByClassName("TextBlurb") || "";
      this.MaxHeight = 0;
      for (let i = 0; i < TextBoxHeight.length; i++) {
        if (TextBoxHeight[i].offsetHeight > this.MaxHeight) {
          this.MaxHeight = TextBoxHeight[i].offsetHeight;
        }
      }
      var r = document.querySelector(":root");
      r.style.setProperty("--MaxHeightCalc", this.MaxHeight + "px");
    },
    goToSeraph() {
      window.location.href = "https://www.angel-guard.co.uk/seraph-protect";
    },
  },
  updated: function() {
    this.$nextTick(function() {
      this.boxHeight();
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },
};
</script>

<style>
:root {
  --MaxHeightCalc: 14px;
}

.BackgroundSection {
  background: rgb(255, 255, 255);
  min-width: 100vw;
  min-height: 100vh;
  border: none;
  padding: none;
  border: 0;
  padding: 0;
  background-size: cover;
}

div.Login {
  align-content: center;
  text-align: center;
}
.bigImage {
  z-index: 0;
  filter: blur(12px) grayscale(0.75);
  background-position: center;
  opacity: 0.3;
  height: 100vh;
  width: 100vw;
  overflow: none;
}
.smallImage {
  z-index: 2;
  margin-top: 3rem;
  margin-bottom: 3rem;
  margin-left: 40vw;
  width: 20vw;
  overflow: none;
}
.smallImageMobile {
  z-index: 2;
  margin-top: 3rem;
  margin-bottom: 3rem;
  margin-left: 35vw;
  width: 30vw;
  overflow: none;
}
.container_row {
  display: grid;
  height: 100vh;
}

.layer1,
.layer2 {
  grid-column: 1;
  grid-row: 1;
}

.layer1 span {
  display: grid;
  place-items: center;
  margin: auto, auto, auto, auto;
}


.alignCentre {
  width: 40vw;
  margin-left: auto;
  margin-right: auto;
  color: rgb(255, 255, 255);
  align-content: center;
  text-align: center;
  padding-bottom: 2rem;
}
.alignCentreMob {
  width: 75vw;
  margin-left: auto;
  margin-right: auto;
  color: rgb(255, 255, 255);
  align-content: center;
  text-align: center;
  padding-bottom: 2rem;
}
.leftCol {
  background-color: rgba(48, 52, 62, 0.7);
  padding-top: 2rem;
  padding-bottom: 2rem;

}
.rightCol {
  background-color: rgba(48, 52, 62, 0.7);
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.subtextHead {
  color: rgba(78, 205, 196);
  font-weight: bold;
}

.HomeButton:hover {
  background-color: rgb(78, 205, 196);
  border: 1px solid transparent;
  color: black;
}

.HomeButton {
  color: #ffffff;
  background-color: #30343e;
  border-color: #30343e;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: 1.25s;
}

.TextBlurb {
  min-height: var(--MaxHeightCalc);
}
</style>
